import React from 'react';
import HeaderElement from '../components/HeaderElement';
import Footer from '../components/Footer';
import ContactUs from '../components/ContactUs';

const Reservations = () => {
  return (
    <div>
      <HeaderElement />
      <ContactUs />
      <Footer />
    </div>
  );
};

export default Reservations;
